import { Component, Inject, OnInit } from '@angular/core';
import { ComponentActionHistroyVM } from '../../../../../app/modules/manage-components/manage-components.model';
import { LoadingService } from '../../../../../app/shared/services/loading.service';
import { UserService } from '../../../../../app/shared/services/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-component-action-history',
  templateUrl: './component-action-history.component.html',
  styleUrls: ['./component-action-history.component.scss']
})
export class ComponentActionHistoryComponent implements OnInit {

  componentHistroy:ComponentActionHistroyVM[]
  constructor(
    private _loading: LoadingService,
    private _user: UserService,
    public dialogRef: MatDialogRef<ComponentActionHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

  }
  ngOnInit() {
    this.componentHistroy=this.data.componentHistroy;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
